<template>
  <router-link
    :to="{
      name: 'product-details',
      params: { id: product.id }
    }"
    class="product-card rounded-16 p-6 bg-5"
  >
    <div class="image-container mb-4">
      <img :src="image" alt="produto" v-if="image" />
    </div>

    <div class="d-flex justify-content-between align-items-start mb-2">
      <div>
        <div class="text-semibold fs-14">{{ product.name }}</div>
        <div class="text-dark-40 fs-12">
          {{ formatProductType(product.type_product) }}
        </div>
      </div>
      <div :class="formatStatusClass(product.status)">
        {{ formatStatus(product.status) }}
      </div>
    </div>

    <div class="text-dark-80 fs-12 mb-4">
      Criado em {{ formatDate(product.created_at) }}
    </div>

    <div class="d-flex justify-content-between">
      <snow-button
        size="sm"
        icon="ph ph-link"
        variant="outline"
        text="Links de divulgação"
        @click="openLinks"
      />

      <bp-dropdown
        class="dropdown"
        :actions="actions"
        :variant="isGallery ? 'filled-2' : 'glyph'"
        @links="openLinks"
        @duplicate="duplicate"
        @deactivate="changeStatus('inactive')"
      />
    </div>
  </router-link>
</template>

<script>
import { approvalMessageUrl } from "@/functions/product";
import ProductActionsMixin from "@/mixins/productActions.js";

export default {
  mixins: [ProductActionsMixin],
  props: {
    isGallery: Boolean,
    product: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    image() {
      return this.product?.picture || null;
    },
    actions() {
      const actions = [
        {
          text: "Duplicar produto",
          icon: "fa-light fa-copy",
          event: "duplicate"
        },
        {
          text: "Links de divulgação",
          icon: "fa-light fa-link",
          event: "links"
        }
      ];

      if (this.product.status == "active") {
        actions.push({
          text: "Desativar produto",
          class: "text-negative-600",
          icon: "fa-light fa-power-off",
          confirmation: {
            text:
              "Tem certeza que deseja desativar este produto? Ao confirmar este produto não estará mais disponível para compra até que você o reative.",
            variant: "negative",
            buttonText: "Cancelar",
            secondaryButtonText: "Desativar",
            icon: "fa fa-hexagon-exclamation",
            secondary: true
          },
          event: "deactivate"
        });
      } else if (this.product.status == "inactive") {
        actions.push({
          text: "Ativar produto",
          class: "text-positive-600",
          icon: "fa-light fa-power-off",
          confirmation: {
            icon: "fa fa-hexagon-exclamation",
            variant: "alert",
            buttonText: "Entendido",
            text:
              "Entre em contato com o suporte para solicitar a ativação do produto."
          }
        });
      }

      return actions;
    },
    inReview() {
      return !!["in_review", "draft"].includes(this.product.status);
    }
  },
  methods: {
    formatStatus(status) {
      return {
        active: "Ativo",
        inactive: "Inativo",
        draft: "Pendente",
        in_review: "Em revisão",
        reject: "Rejeitado"
      }[status];
    },
    formatStatusClass(status) {
      return {
        active: "active-badge",
        inactive: "inactive-badge",
        draft: "draft-badge",
        in_review: "draft-badge",
        reject: "inactive-badge"
      }[status];
    },
    formatProductType(type_product) {
      return {
        online_course: "Curso Online",
        signature: "Assinatura",
        onsite_event: "Evento presencial"
      }[type_product];
    },
    formatDate(value) {
      return new Date(value).toLocaleDateString("pt-BR");
    },

    requestApproval() {
      window.open(
        approvalMessageUrl(
          this.product,
          this.$user.user,
          this.$config.get("whatsapp_support")
        ),
        "_blank"
      );
    },
    duplicate() {
      this.$store.dispatch("product/duplicate", this.product.id).then(() => {
        this.$message.success("Produto duplicado!");
        this.$emit("refresh");
      });
    },
    openLinks() {
      this.$router.push({
        name: "product-links",
        params: { id: this.product.id }
      });
    },
    changeStatus(status) {
      this.$store
        .dispatch("product/put", { id: this.product.id, status })
        .then(() => {
          this.$message.success(
            `O Produto foi ${status == "active" ? "ativado" : "desativado"}!`
          );
          this.$emit("refresh");
        })
        .catch(() => {
          this.$message.error("Erro ao atualizar status do produto");
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.product-card {
  display: block;
  position: relative;
  color: var(--dark);
  text-decoration: none;
  height: 100%;
  transition: 0.2s all;
  border: 1px solid var(--dark-10);
  padding: 24px;

  &:hover {
    border-color: var(--dark-20);

    .dropdown {
      opacity: 1 !important;
    }
  }

  .image-container {
    width: 100%;
    aspect-ratio: 1.28;
    background-color: var(--dark-4);
    border-radius: 12px;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}
</style>
